import { render, staticRenderFns } from "./AddToLibraryButton.vue?vue&type=template&id=8927966c&scoped=true&"
import script from "./AddToLibraryButton.vue?vue&type=script&lang=js&"
export * from "./AddToLibraryButton.vue?vue&type=script&lang=js&"
import style0 from "./AddToLibraryButton.vue?vue&type=style&index=0&id=8927966c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8927966c",
  null
  
)

export default component.exports